import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Podcast } from '@/types/Podcast';
import AirbnbCard from './AirbnbCard';
import { useFavorites } from '@/hooks/useFavorites';
import { calculateDistance, formatDistance } from '@/services/locationService';

interface VisitCarouselProps {
  title: string;
  podcasts: Podcast[];
  userLocation?: [number, number] | null;
  onPodcastSelect: (podcast: Podcast) => void;
  showDistance?: boolean;
  onTitleClick?: () => void;
  isFirstCarousel?: boolean;
}

const VisitCarousel: React.FC<VisitCarouselProps> = ({
  title,
  podcasts,
  userLocation,
  onPodcastSelect,
  showDistance = false,
  onTitleClick,
  isFirstCarousel = false
}) => {
  const { toggleFavorite, isFavorite } = useFavorites();

  if (!podcasts.length) {
    return null;
  }

  return (
    <div className="mb-8">
      <div 
        className={`flex items-center justify-between mb-4 px-6 ${
          onTitleClick ? 'cursor-pointer' : ''
        }`}
        onClick={onTitleClick}
      >
        <h2 className="text-xl font-semibold text-gray-900">{title}</h2>
        {onTitleClick && (
          <ChevronRight className="w-5 h-5 text-gray-800" />
        )}
      </div>
      
      <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide px-6">
        {podcasts.map((podcast, index) => {
          const distance = userLocation && showDistance
            ? calculateDistance(
                userLocation[0], 
                userLocation[1], 
                podcast.Latitude, 
                podcast.Longitude
              )
            : undefined;

          return (
            <AirbnbCard
              key={`${podcast.Name}-${index}`}
              id={podcast.Name}
              image={podcast.Image || undefined}
              title={podcast.Name}
              subtitle={`${podcast.City}, ${podcast.Country}`}
              distance={distance ? formatDistance(distance) : undefined}
              rating={podcast.Note_Google || undefined}
              priority={isFirstCarousel && index === 0}
              onCardClick={() => onPodcastSelect(podcast)}
              onFavoriteClick={() => toggleFavorite(podcast.Name)}
              isFavorite={isFavorite(podcast.Name)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default VisitCarousel;